import React, { Fragment, PureComponent } from 'react';
import { func, string } from 'prop-types';
import { TextField, Box } from '@mui/material';
import { Button } from '../../Button';
import IntlMessages from '../../../util/IntlMessages';
import { AUTH_ERROR_TYPES } from '../../../constants/Values';

/**
 * Represents stateless functional component CodeVerificationForm
 * Asks user to enter verification code received via SMS/Email
 * @param {object} props Component props
 * @param {function} props.onFieldChange Password change callback function
 * @param {function} props.showAuthLoader Shows form loader if form is submitted
 * @param {String} props.identifier Represents verification code
 * @param {function} props.verifyUserSignUp Dispatches an action of a specific type
 * @return {Component}
 * */
class CodeVerificationForm extends PureComponent {
  static propTypes = {
    errorMessage: string,
    handleBackClick: func,
    onFieldChange: func,
    resetErrorMessage: func,
    showAuthLoader: func,
    verificationCode: string,
    verifyUserSignUp: func,
  };

  static defaultProps = {
    errorMessage: '',
    handleBackClick: () => {},
    onFieldChange: () => {},
    resetErrorMessage: () => {},
    showAuthLoader: () => {},
    verificationCode: '',
    verifyUserSignUp: () => {},
  };

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.resetErrorMessage(AUTH_ERROR_TYPES.VERIFICATION_CODE);
    }
  }

  onFormSubmit = event => {
    event.preventDefault();

    if (!this.props.verificationCode) {
      return;
    }

    this.verifyUserSignUp();
  };

  handleFieldChange = event => this.props.onFieldChange(event.target.id, event.target.value);

  verifyUserSignUp = () => {
    this.props.showAuthLoader();
    this.props.verifyUserSignUp();
  };

  render() {
    return (
      <Fragment>
        <Box className="app-login-header" sx={{ mb: 3 }}>
          <h2>
            <IntlMessages id="auth.verificationCode.header" />
          </h2>
        </Box>
        <div className="app-login-form">
          <form onSubmit={this.onFormSubmit}>
            <fieldset>
              <TextField
                autoFocus
                sx={{ mt: { xs: 1, sm: 3 }, mb: { xs: 1, sm: 3 } }}
                defaultValue={this.props.verificationCode}
                error={!!this.props.errorMessage}
                fullWidth
                helperText={
                  <IntlMessages
                    id={this.props.errorMessage || 'auth.verificationCode.helperText'}
                  />
                }
                id="verificationCode"
                label={<IntlMessages id="auth.verificationCode.label" />}
                margin="normal"
                onChange={this.handleFieldChange}
              />
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Button
                  size="large"
                  labelId="appModule.back"
                  onClick={this.props.handleBackClick}
                  variant="text"
                />
                <Button
                  size="large"
                  labelId="auth.verificationCode.buttonText"
                  color="primary"
                  disabled={!this.props.verificationCode}
                  type="submit"
                  variant="contained"
                />
              </Box>
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default CodeVerificationForm;
